import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/sv';

import { getOrderBySessionId } from '../state/actions/order';
import '../styles/success.scss';

function PaymentSuccess() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { sessionOrder, sessionOrderLoading, sessionOrderError } = useSelector(
    (state) => state.order
  );

  // Read session_id from the URL query string
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (sessionId) {
      dispatch(getOrderBySessionId(sessionId));
    }
  }, [dispatch]);

  moment.locale(i18n.resolvedLanguage || 'sv');

  const order = sessionOrder?.order || sessionOrder;
  const deliveryDate = order?.delivery_date;
  const primaryLocation = order?.primary_delivery_location;
  const secondaryLocation = order?.secondary_delivery_location;

  return (
    <div className="container success-container text-center">
      <h1>{t('payment_success_title', 'Betalningen genomförd!')}</h1>
      <p>
        {t(
          'payment_success_message',
          'Tack för din betalning. Du kommer att få kvitto via e-post inom kort.'
        )}
      </p>

      {sessionOrderLoading && <p>{t('payment_loading', 'Hämtar orderinformation...')}</p>}

      {sessionOrderError && (
        <p className="text-danger">{t('payment_error', 'Kunde inte hämta orderinformation.')}</p>
      )}

      {!sessionOrderLoading && primaryLocation && (
        <p>
          {t('payment_delivery_primary', 'Dina varor finns tillgängliga på')}{' '}
          <strong>{primaryLocation}</strong>{' '}
          {t('payment_delivery_primary_suffix', 'din bokade dag')}
          {deliveryDate && (
            <>
              <br />
              <strong>{moment(deliveryDate).format('D MMMM YYYY')}</strong>
            </>
          )}
        </p>
      )}

      {!sessionOrderLoading && secondaryLocation && (
        <p>
          {t(
            'payment_delivery_secondary',
            'Om upphämtning uteblir kan du hämta dem i efterhand på'
          )}{' '}
          <strong>{secondaryLocation}</strong>
        </p>
      )}
    </div>
  );
}

export default PaymentSuccess;
